import { clearAppCaches } from '@/utils/clearAppCaches';
import { useTranslation } from 'react-i18next';

/**
 * Écran de secours affiché si le rechargement automatique après une erreur
 * de chunk a échoué plusieurs fois. Donne à l'utilisateur un bouton manuel
 * pour relancer un nettoyage complet + reload.
 */
export function UpdateRecoveryScreen() {
  const { t } = useTranslation('appui');
  const handleReload = async () => {
    try {
      sessionStorage.removeItem('chunk_reload_attempts');
    } catch {
      /* noop */
    }
    await clearAppCaches();
    window.location.reload();
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        background: '#ffffff',
        color: '#0f172a',
      }}
    >
      <div style={{ maxWidth: 360 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
          {t('updateRecovery.title')}
        </h1>
        <p style={{ fontSize: 14, lineHeight: 1.5, color: '#475569', marginBottom: 24 }}>
          {t('updateRecovery.description')}
        </p>
        <button
          type="button"
          onClick={handleReload}
          style={{
            background: '#2563eb',
            color: '#ffffff',
            border: 'none',
            borderRadius: 8,
            padding: '12px 24px',
            fontSize: 15,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          {t('updateRecovery.button')}
        </button>
      </div>
    </div>
  );
}
